export default {
  'global#home': 'Home',
  'global#works': 'Works',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Sorry, an error occurred',
  'global#layout_error_description': 'Please try reloading the page in a moment. If the issue persists, contact the platform administrator.',
  'global#facet_empty_text': 'No results',
  'readmore#label': 'Show all',
  'search#editions_title': 'Digital Editions',
  'search#works_title': 'Mapping Chivalry <br>Progetto Mambrino Database Bibliografico (PMDB)',
  'search#works_total': '<strong>{ total }</strong> Works',
  'search#news_total': '<strong>{ total }</strong> News',
  'search#news_total_0': 'No News',
  'search#works_total_1': '<strong>{ total }</strong> Work',
  'search#characters_total': '<strong>{ total }</strong> Characters',
  'search#characters_total_1': '<strong>{ total }</strong> Character',
  'search#motifs_title': 'Motif Index',
  'search#places_total_0': 'No Places',
  'search#motifs_total': '<strong>{ total }</strong> Motifs',
  'search#motifs_total_1': '<strong>{ total }</strong> Motif',
  'search#motifs_total_0': 'No Motifs',
  'search#places_total': '<strong>{ total }</strong> Places',
  'search#places_total_1': '<strong>{ total }</strong> Place',
  'search#works_total_0': 'No Works',
  'search#books_total': '<strong>{ total }</strong> Books',
  'search#books_total_1': '<strong>{ total }</strong> Book',
  'search#books_total_0': 'No Books',
  'search#placeholder_query': 'Search in titles',
  'search#character_placeholder_query': 'Search in names',
  'search#resultsamount': 'Show results',
  'search#header_authors': 'Authors',
  'search#header_languages': 'Language',
  'search#characters_title': 'Character Index',
  'search#places_title': 'Place Index',
  'search#header_subjects': 'Subjects',
  'search#header_traits': 'Traits',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Works',
  'search#header_libraries': 'Library',
  'search#header_motif_type': 'Motif Types',
  'search#header_romances': 'Romances',
  'search#header_cycles': 'Cycles',
  'search#header_cities': 'Cities',
  'search#header_dates': 'Dates',
  'search#header_curators': 'Curators',
  'search#header_forenames': 'First Names',
  'search#header_in_works': 'Works of Appearance',
  'search#header_translators': 'Translators',
  'search#facets_title': 'Filter Results',
  'search#filters_title': 'Active Filters:',
  'search#sort_title': 'Sort',
  'search#sort_label_ciclo': 'Order by position in the cycle',
  'search#sort_score': 'Order by relevance',
  'search#sort_asc': 'Alphabetical order (A→Z)',
  'search#sort_desc': 'Alphabetical order (Z→A)',
  'search#sort_data_desc': 'Latest',
  'search#fallback_text': 'Your search returned no results. Try changing the parameters or reset the search by clicking the button below.',
  'search#fallback_button': 'Reset search',
  'search#ko_text': 'Oops, we encountered an error in the search. Try changing the parameters or reset the search by clicking the button below.',
  'search#ko_button': 'Reset search',
  'search#description_button': 'Info',
  'search#description_link': 'Ok, I understand',
  'search#redirect_link': 'Advanced search',
  'resource#authors': 'by',
  'resource#date': 'published on',
  'resource#time_to_read': 'reading time',
  'resource#metadata': 'Metadata',
  'resource#complete-title': 'Complete title',
  'resource#collection-sources': 'related sources',
  'resource#collection-editions': 'related editions',
  'resource#collection-samples': 'Samples',
  'resource#collection-translations': 'related translations',
  'resource#collection-digital-editions': 'Digital editions',
  'resource#collection-text': 'Digital edition',
  'resource#collection-antroponimi': 'Related anthroponyms',
  'resource#collection-toponimi': 'Related toponyms',
  'resource#parent-record': 'Reference work',
  'resource#parent-edition': 'Edition',
  'resource#occurrences': 'Occurrences',
  'resource#metadata_size': 'Size',
  'search#header_genres': 'Genre',
  'search#header_language': 'Language',
  'search#date': 'date',
  'search#bibliographies_total': '<strong>{ total }</strong> bibliographic references',
  'search#bibliographies_total_1': '<strong>{ total }</strong> bibliographic reference',
  'search#bibliographies_total_0': 'No bibliographic reference',
  'search#placeholder_authors': 'Search for an author',
  'search#title_bibliographies': 'Bibliography',
  'search#header_sex': 'Sex',
  'search#motif_placeholder_query': 'Search for motif',
  'readmore#more': 'Show more',
  'readmore#less': 'Show less',
  'advancedsearch#title': 'Search',
  'advancedsearch#works_total': '<strong>{ total }</strong> Results',
  'advancedsearch#works_total_1': '<strong>{ total }</strong> Result',
  'advancedsearch#filters_title': 'Active filters',
  'advancedsearch#works_total_0': 'No Result found',
  'advancedsearch#search_in_title': 'Search in:',
  'advancedsearch#label_title': 'Title',
  'advancedsearch#label_work_title': 'Select a work',
  'advancedsearch#label_work_title_info':
    'Select the title of the work in which you want to search. Do not indicate any entry if you want to search in all works',
  'advancedsearch#label_resource_type': 'Resource type',
  'advancedsearch#label_text': 'Search the texts',
  'advancedsearch#label_search_title': 'Search the texts',
  'advancedsearch#label_content': 'Contents',
  'advancedsearch#fulltext_text': 'Search the portal (all fields)',
  'advancedsearch#fulltext_info':
    'Search a term in all sections of the portal.',
  'advancedsearch#section_info':
    'Please specify the section or sections you would like to search.',
  'advancedsearch#label_textual': 'Textual search',
  'advancedsearch#intro':
    'In this section it is possible to query, in a simple or crossed way, the data present in the portal.\n"Search portal" allows to extract, through a general search, results from the various sections that can be queried individually or simultaneously. \n"Search in works" allows a textual search, by lemma and/or by voice of authority, within the works of Petrarch and the ancient biographies dedicated to him.',
  'advancedsearch#search_portal': 'Search the porta',
  'advancedsearch#library_text': 'Library',
  'advancedsearch#label_signature': 'Signature',
  'advancedsearch#section_global': 'Search the portal',
  'advancedsearch#section_work': 'Search in works',
  'advancedsearch#section_edition': 'Search in editions',
  'advancedsearch#section_sample': 'Search in samples',
  'advancedsearch#label_works': 'Works',
  'advancedsearch#label_editions': 'Editions',
  'advancedsearch#label_samples': 'Samples',
  'advancedsearch#label_translator': 'Translator',
  'advancedsearch#label_place': 'Edition place',
  'advancedsearch#label_cycle': 'Cycle',
  'advancedsearch#label_subject': 'Subject',
  'advancedsearch#language': 'Language',
  'advancedsearch#label_editor': 'Editor',
  'advancedsearch#label_dedica': 'Dedicatee',
  'advancedsearch#label_year': 'Date',
  'advancedsearch#label_editorial-mark': 'Editorial marck',
  'advancedsearch#label_id_pmdb': 'ID PMDB',
  'advancedsearch#marginalia_label': 'Marginalia',
  'advancedsearch#reproduction_label': 'Photographic edition',
  'advancedsearch#digital_edition_label': 'Digital edition',
  'advancedsearch#value_exists': 'Yes',
  'advancedsearch#value_not_exists': 'No',
  'advancedsearch#label_library_city': 'Library city',
  'advancedsearch#label_library': 'Library',
  'advancedsearch#label_note': 'Description and notes',
  'advancedsearch#label_previous_owner': 'Previous owner',
  'advancedsearch#label_type': 'search in:',
  'advancedsearch#advanced_search': 'Advanced search',
  'advancedsearch#section_textual': 'Search the works',
  'advancedsearch#label_manuscript_content': 'Manuscripts content',
  'advancedsearch#text_info':
    'By querying by lemma, you can use special characters to refine it: * corresponds to any number of characters and you can use it anywhere in a character string; ? matches a single alphabetic character in a specific position of a string. once the search has started, selecting the individual results you will be directed to the section of the work where the occurrence is present; to reach the exact portion of the text you can then scroll through the text or, alternatively, make a quick search using the command CTRL+F',
  'advancedsearch#include_authority': 'Authority entry',
  'advancedsearch#text_title': 'search lemma',
  'advancedsearch#querytext_authority_info':
    'Allows you to query the vocabulary of names and places present in Petrarch\'s works. Eg. searching "Rome" the search will not only return the entered lemma but also all the cases in which the author names a place identified as "Rome" by the publisher of the electronic edition of the text',
  'advancedsearch#querytext_authority_label': 'includes authority entry',
  'advancedsearch#label_text_distance': 'Proximity search',
  'advancedsearch#label_name': 'People',
  'advancedsearch#label_autorithy_name': 'People (authority entry)',
  'advancedsearch#label_autorithy_place': 'Places (authority entry)',
  'advancedsearch#label_name_info': 'Search name selecting the authority entry',
  'advancedsearch#label_place_info':
    'Search place selecting the authority entry',
  'advancedsearch#label_text_bibl': 'Search the sources',
  'advancedsearch#label_bibl': 'Sources',
  'advancedsearch#label_witnesses': 'Witnesses',
  'advancedsearch#label_timeline': 'Timeline',
  'advancedsearch#label_work': 'Works',
  'advancedsearch#label_itineraries': 'Itinerary',
  'advancedsearch#label_biographies': 'Ancient lifes',
  'advancedsearch#label_type_text': 'Search in texts from section:',
  'advancedsearch#label_bibliography': 'Bibliography',
  'advancedsearch#label_tools': 'Tools',
  'advancedsearch#label_source': 'source',
  'advancedsearch#distance_value': 'Interposed words',
  'advancedsearch#distance_text': 'Text',
  'advancedsearch#label_bibl_info':
    'Select the title of a source to retrieve all the passages that Petrarch draws from and cites in his works. You can refine the query by choosing the specific words to search in the above mask. Do not indicate any source if you intend to search everywhere.',
  'advancedsearch#highlights_title': 'Results',
  'advancedsearch#reset': 'Clear fields',
  'advancedsearch#submit': 'Search',
};
